var map = {
	"./ADA.png": 3533,
	"./ADX.png": 5300,
	"./AE.png": 5732,
	"./ARDR.png": 808,
	"./ARK.png": 5238,
	"./BAT.png": 7646,
	"./BCC.png": 1617,
	"./BCH.png": 8373,
	"./BCN.png": 3948,
	"./BLOCK.png": 5986,
	"./BNB.png": 5124,
	"./BNT.png": 8851,
	"./BTC.png": 5294,
	"./BTCD.png": 6792,
	"./BTG.png": 6587,
	"./BTM.png": 9319,
	"./BTS.png": 6842,
	"./CNX.png": 4179,
	"./CVC.png": 4518,
	"./DASH.png": 4980,
	"./DCR.png": 922,
	"./DGB.png": 7151,
	"./DGD.png": 3894,
	"./DOGE.png": 6685,
	"./EDG.png": 4357,
	"./EMC2.png": 4536,
	"./EOS.png": 4862,
	"./ETC.png": 6719,
	"./ETH.png": 950,
	"./ETHOS.png": 5565,
	"./ETHW.png": 2169,
	"./ETP.png": 4017,
	"./FCT.png": 7545,
	"./FUN.png": 8865,
	"./GAME.png": 8415,
	"./GAS.png": 5505,
	"./GBYTE.png": 4917,
	"./GNO.png": 2590,
	"./GNT.png": 6874,
	"./GRS.png": 9783,
	"./GXS.png": 6534,
	"./HSR.png": 4932,
	"./ICN.png": 4331,
	"./IOT.png": 4517,
	"./KMD.png": 1023,
	"./KNC.png": 4810,
	"./LSK.png": 2856,
	"./LTC.png": 4655,
	"./MAID.png": 7703,
	"./MCO.png": 3645,
	"./MNX.png": 9649,
	"./MONA.png": 5532,
	"./MTL.png": 7905,
	"./NAV.png": 8453,
	"./NEO.png": 7632,
	"./NXS.png": 7064,
	"./NXT.png": 5925,
	"./OMG.png": 2288,
	"./PAY.png": 2740,
	"./PIVX.png": 1069,
	"./POT.png": 1686,
	"./POWER.png": 940,
	"./PPC.png": 9978,
	"./PPT.png": 5396,
	"./PURA.png": 7754,
	"./QASH.png": 9710,
	"./QTUM.png": 3783,
	"./RDN.png": 7258,
	"./REP.png": 2885,
	"./RVN.png": 7691,
	"./SALT.png": 5163,
	"./SAN.png": 3824,
	"./SC.png": 8259,
	"./SKY.png": 3997,
	"./SNGLS.png": 3184,
	"./SNT.png": 9646,
	"./START.png": 2515,
	"./STEEM.png": 4893,
	"./STORJ.png": 3552,
	"./SYS.png": 7505,
	"./TRX.png": 7714,
	"./UBQ.png": 4984,
	"./USDT.png": 8508,
	"./VEN.png": 6983,
	"./VTC.png": 2528,
	"./WAVES.png": 928,
	"./WTC.png": 8783,
	"./XEM.png": 2301,
	"./XLM.png": 5619,
	"./XMR.png": 3571,
	"./XRP.png": 9151,
	"./XUC.png": 1192,
	"./XVG.png": 1581,
	"./XZC.png": 2371,
	"./ZEC.png": 5432,
	"./ZEN.png": 9210,
	"./ZRX.png": 4408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2954;